import React from 'react';
import Table from 'react-bootstrap/Table';
import FormCheck from 'react-bootstrap/FormCheck';
import { useMedia } from 'react-use';
import { PriceListItem } from '../store/priceListItemsStore';

interface PriceListEditNoClassifierProps {
  items: PriceListItem[];
  permissions?: any;
  deleteMode?: boolean;
  /** Только просмотр: цена — текст, без полей ввода и обработчиков */
  readOnly?: boolean;
  onPriceChange?: (itemId: string, event: any) => void;
  onPriceInput?: (itemId: string, event: any) => void;
  onDeleteChange?: (itemId: string) => void;
}

const PriceListEditNoClassifier: React.FC<PriceListEditNoClassifierProps> = ({
  items,
  permissions,
  deleteMode,
  readOnly,
  onPriceChange,
  onPriceInput,
  onDeleteChange,
}) => {

  // Планшет/телефон: половина ширины экрана — слишком узко, таблица на всю ширину
  const isTabMobile = useMedia('(max-width: 991px)');

  return (
    <>
      <style>{ `
        .no-classifier-table td {
          padding: 0.25rem 0.4rem !important;
          line-height: 1.2;
          vertical-align: middle;
        }
        .no-classifier-table input.form-control {
          padding: 0.15rem 0.3rem;
          font-size: 0.85rem;
          height: 30px;
          border: none;
          background-color: transparent;
        }
        .no-classifier-table input.form-control:focus {
          background-color: #fff;
          border: 1px solid #ced4da;
          outline: none;
          box-shadow: none;
        }
        .no-classifier-table input[type="number"]::-webkit-inner-spin-button,
        .no-classifier-table input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        .no-classifier-table input[type="number"] {
          -moz-appearance: textfield;
        }
        .no-classifier-table tbody tr {
          height: 36px;
        }
        /* Шапка как у «Розничных цен» (PriceListEditTableV3 .price-list-table thead th) */
        .no-classifier-table thead th {
          height: 50px !important;
          vertical-align: middle !important;
          text-align: center !important;
          padding: 0.75rem 0.5rem !important;
          font-weight: 600;
          position: sticky;
          top: 0;
          z-index: 2;
          background-color: #e9ecef;
          font-size: 0.95rem;
        }
      ` }</style>
      
      <div>
        <h5 className='mb-3 font-weight-bold'>Дополнительные позиции</h5>
        <div className={ isTabMobile ? 'w-100' : 'w-50' }>
          <Table className='no-classifier-table table-bordered table-hover table-sm' responsive>
            <thead className='thead-light'>
              <tr>
                { /* <th style={ { width: '100px' } }>Артикул</th> */ }
                <th style={ { width: '250px' } }>Позиция</th>
                <th style={ { width: '100px' } }>Цена</th>
                { deleteMode && <th style={ { width: '60px' } }>Удалить</th> }
              </tr>
            </thead>
            <tbody>
              { items.map((item) => (
                <tr key={ item.id }>
                  { /* <td className='font-weight-bold text-muted small'>{ item.positionVendorCode }</td> */ }
                  <td className='small text-truncate' title={ item.positionShortName }>{ item.positionShortName }</td>
                  <td>
                    { readOnly
                      ? <span className='small'>{ item.price ?? '—' }</span>
                      : (
                        <input
                          type='number'
                          className='form-control form-control-sm'
                          value={ item.value ?? item.price ?? '' }
                          onBlur={ (e) => onPriceChange(item.id, e) }
                          onChange={ (e) => onPriceInput(item.id, e) }
                          disabled={ !permissions?.permissionUpdate }
                        />
                      ) }
                  </td>
                  { deleteMode && (
                    <td className='text-center'>
                      <FormCheck
                        type='checkbox'
                        checked={ item.markedToDelete || false }
                        onChange={ () => onDeleteChange(item.id) }
                        className='justify-content-center'
                      />
                    </td>
                  ) }
                </tr>
              )) }
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default PriceListEditNoClassifier;